module.exports = __webpack_public_path__ + "media/images/icon_about1-a3dcdc84ad6f2cfedce12dc22cfc24e1.png";